/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CancellationFeedbackService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create a CancellationFeedback record for an organization
     * This is used when an organization linked to Tithely
     * request cancellation, so we can store the reason and other details.
     * @returns void
     * @throws ApiError
     */
    public createCancellationFeedbackRecord({
        reason,
        reasonFeatures,
        reasonFeaturesComment,
        comment,
        switchedTo,
        switchedToReason,
    }: {
        /**
         * Reason for cancellation
         */
        reason: string,
        /**
         * Reason for cancellation due to missing features
         */
        reasonFeatures: string,
        /**
         * Comment about cancellation due to missing features
         */
        reasonFeaturesComment: string,
        /**
         * Additional comments
         */
        comment: string,
        /**
         * ChMS switched to
         */
        switchedTo?: string,
        /**
         * Reason ChMS was switched to
         */
        switchedToReason?: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/cancellation',
            query: {
                'reason': reason,
                'reason_features': reasonFeatures,
                'reason_features_comment': reasonFeaturesComment,
                'comment': comment,
                'switched_to': switchedTo,
                'switched_to_reason': switchedToReason,
            },
            errors: {
                400: `Bad request`,
            },
        });
    }

}
